// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────────
   CablingDesigner — lienzo de extremos cableables
   Reutiliza las clases \`swd-*\` del diseñador de switches (toolbar, lateral,
   modal, zoom). Aquí solo va lo propio: filtros, cajas de armario, tarjetas
   compactas, puertos y la ficha de cadena.
   ──────────────────────────────────────────────────────────────────────────── */

.cbd-page {
  --cbd-wall: #22c55e;
  --cbd-backbone: #8b5cf6;
  --cbd-free: #86efac;
  --cbd-busy: #3b82f6;
  --cbd-external: #f59e0b;
}

/* Iconografía @heroicons/react/24/outline, mismo tamaño en toda la barra. */
.cbd-ico {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  stroke-width: 1.7;
}
.cbd-ico.is-kind { width: 13px; height: 13px; opacity: 0.75; vertical-align: -2px; }
.swd-btn .cbd-ico { pointer-events: none; }

/* Panel izquierdo plegado: el lienzo se queda con todo el ancho. */
.swd-body.is-side-collapsed .swd-side { display: none; }

/* Ojo y nombre con iconos (antes eran emojis). */
.cbd-page .swd-eye {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}
.cbd-page .swd-side-name {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

/* ── Lista de nodos agrupada por tipo ────────────────────────────────────── */
.cbd-side-group { display: flex; flex-direction: column; }
.cbd-side-group + .cbd-side-group { margin-top: 2px; }
/* La cabecera es un contenedor: dentro va el botón que pliega y las acciones
   de ocultar/mostrar todo el grupo (un botón no puede llevar botones dentro). */
.cbd-side-group-head {
  display: flex;
  align-items: center;
  gap: 2px;
  width: 100%;
  padding: 0;
  border-radius: 6px;
  color: var(--text-secondary);
}
.cbd-side-group-head:hover { background: var(--bg-toolbar); }
.cbd-side-group-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  padding: 5px 4px 5px 6px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: inherit;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
  text-align: left;
}
.cbd-side-group-head:hover .cbd-side-group-toggle { color: var(--text-primary); }
.cbd-side-group-actions {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  padding-right: 3px;
  opacity: 0.55;
  transition: opacity 0.12s;
}
.cbd-side-group-head:hover .cbd-side-group-actions { opacity: 1; }
.cbd-group-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}
.cbd-group-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }
.cbd-group-btn:disabled { opacity: 0.3; cursor: default; }
.cbd-side-group-name { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cbd-side-group-head em {
  font-style: normal;
  font-size: 0.66rem;
  font-weight: 700;
  padding: 0 5px;
  border-radius: 8px;
  background: var(--bg-toolbar);
  color: var(--text-muted);
}

/* Acciones de la cabecera de la lista: ocultar todo / mostrar todo. */
.cbd-side-head-actions { display: inline-flex; align-items: center; gap: 8px; }
.cbd-head-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 4px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
}
.cbd-head-btn:hover { background: var(--bg-toolbar); color: var(--text-primary); }
.cbd-chain-title { display: inline-flex; align-items: center; gap: 6px; }

/* ── Filtros por tipo ─────────────────────────────────────────────────────── */
.cbd-filters {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.35rem 1rem;
  border-bottom: 1px solid var(--border);
  background: var(--bg-toolbar);
  flex-wrap: wrap;
  flex-shrink: 0;
}
.cbd-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 20px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-card);
  color: var(--text-muted);
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  opacity: 0.55;
  transition: opacity 0.12s, border-color 0.12s, background 0.12s;
}
.cbd-chip em {
  font-style: normal;
  font-size: 0.66rem;
  background: var(--bg-toolbar);
  border-radius: 8px;
  padding: 0 5px;
}
.cbd-chip.is-on {
  opacity: 1;
  border-color: var(--chip);
  color: var(--text-primary);
  background: color-mix(in srgb, var(--chip) 12%, var(--bg-card));
}
.cbd-check {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  font-size: 0.73rem;
  color: var(--text-secondary);
  cursor: pointer;
}

.cbd-select {
  padding: 5px 9px;
  border-radius: 7px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.79rem;
}
.cbd-new { padding-right: 6px; }

/* Modo: solo los nodos con cable a otro extremo dentro del filtro. */
.cbd-only-connected {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cbd-only-connected.is-on {
  background: color-mix(in srgb, var(--swd-accent) 16%, var(--bg-card));
  border-color: var(--swd-accent);
  color: var(--text-primary);
}
.cbd-only-connected em {
  font-style: normal;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0 5px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--swd-accent) 18%, transparent);
  color: var(--text-primary);
}

/* ── Selector de armarios ─────────────────────────────────────────────────── */
.cbd-rack-picker { position: relative; }
.cbd-rack-pop {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 40;
  width: 320px;
  max-height: 380px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-surface);
  box-shadow: var(--shadow-lg, 0 12px 30px rgba(15, 23, 42, 0.25));
}
.cbd-rack-pop input {
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.78rem;
}
.cbd-rack-list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 280px;
}
.cbd-rack-row {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 0.78rem;
  cursor: pointer;
}
.cbd-rack-row:hover { background: var(--bg-toolbar); }
.cbd-rack-row em {
  margin-left: auto;
  font-style: normal;
  font-size: 0.68rem;
  color: var(--text-muted);
}
.cbd-rack-empty {
  padding: 10px;
  text-align: center;
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* ── Cajas de armario / sede ──────────────────────────────────────────────── */
.cbd-group rect {
  fill: color-mix(in srgb, var(--swd-accent) 4%, transparent);
  stroke: var(--border);
  stroke-width: 1.4;
  stroke-dasharray: 6 5;
  cursor: grab;
}
.cbd-group:hover rect {
  stroke: var(--swd-accent);
  fill: color-mix(in srgb, var(--swd-accent) 7%, transparent);
}
.cbd-group-title {
  font-size: 11px;
  font-weight: 700;
  fill: var(--text-secondary);
  letter-spacing: 0.02em;
  pointer-events: none;
}

/* ── Tarjetas ─────────────────────────────────────────────────────────────── */
/* Mismo lenguaje que el Diseñador de switches: cuerpo blanco con sombra,
   borde suave y columna de información a la izquierda. */
.cbd-card { cursor: grab; }
.cbd-card-rect {
  fill: var(--bg-surface);
  stroke: var(--slate-300, #cbd5e1);
  stroke-width: 1.4;
  filter: drop-shadow(0 2px 5px rgba(15, 23, 42, 0.14));
}
.cbd-card:hover .cbd-card-rect {
  stroke: var(--kind, var(--swd-accent));
  stroke-width: 2;
  filter: drop-shadow(0 3px 9px rgba(15, 23, 42, 0.2));
}
.cbd-card.is-design .cbd-card-rect {
  stroke-dasharray: 5 4;
}
/* Columna de información: tinte suave del color del tipo. */
.cbd-card-info {
  fill: color-mix(in srgb, var(--bg-toolbar, #eef2f7) 86%, var(--kind, #64748b) 14%);
  cursor: grab;
}
.cbd-card-bar { fill: var(--kind, var(--swd-accent)); }
.cbd-card-text { cursor: grab; }
.cbd-card-name {
  font-size: 11.5px;
  font-weight: 700;
  fill: var(--text-primary);
}
.cbd-card.is-compact .cbd-card-name { font-size: 11px; }

/* ── Puertos ──────────────────────────────────────────────────────────────── */
.cbd-port { cursor: pointer; }
.cbd-port rect {
  stroke: #0f172a22;
  stroke-width: 1;
  transition: fill 0.1s;
}
.cbd-port.is-free rect { fill: var(--cbd-free); }
.cbd-port.is-free:hover rect { fill: #4ade80; }
.cbd-port.is-busy rect { fill: var(--cbd-busy); }
.cbd-port.is-external rect {
  fill: var(--cbd-external);
  stroke-dasharray: 2 1.5;
}
.cbd-port.is-legacy rect { fill: #fcd34d; }
.cbd-port.is-off rect { fill: #cbd5e1; }
.cbd-port.is-hover rect { stroke: #0f172a; stroke-width: 1.6; }
.cbd-port.is-selected rect {
  fill: #f59e0b;
  stroke: #78350f;
  stroke-width: 2;
}
.cbd-port.is-busy .swd-port-num,
.cbd-port.is-off .swd-port-num { fill: #fff; }

.cbd-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.cbd-dot.is-free { background: var(--cbd-free); }
.cbd-dot.is-busy { background: var(--cbd-busy); }
.cbd-dot.is-external { background: var(--cbd-external); }
.cbd-dot.is-off { background: #cbd5e1; }

/* ── Cables ───────────────────────────────────────────────────────────────── */
.cbd-edge .swd-edge-line { stroke-linecap: round; }
.cbd-edge.is-backbone .swd-edge-line {
  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.45));
}
.cbd-edge.is-wall_run .swd-edge-line { opacity: 0.9; }

/* Camino completo del puerto (debajo del ratón o seleccionado): encendido y
   con corriente recorriéndolo, para que se vea de un vistazo por dónde va. */
.cbd-edge.is-path .swd-edge-line {
  filter: drop-shadow(0 0 7px rgba(59, 130, 246, 0.9));
  stroke-dasharray: 7 5;
  animation: cbd-flow 0.6s linear infinite;
}
@keyframes cbd-flow {
  to { stroke-dashoffset: -12; }
}
@media (prefers-reduced-motion: reduce) {
  .cbd-edge.is-path .swd-edge-line { animation: none; }
}
.cbd-edge.is-path.is-port_connection .swd-edge-line { stroke-width: 5; }
.cbd-edge.is-path.is-backbone .swd-edge-line { stroke-width: 9; }
.cbd-edge.is-path.is-wall_run .swd-edge-line { stroke-width: 4; opacity: 1; }
.cbd-edge.is-dim .swd-edge-line { opacity: 0.14; }

/* El trocito de dentro de la tarjeta (del conector al borde) también se
   enciende: si no, el camino parecía cortado justo en el puerto. */
.swd-lead.is-path {
  opacity: 1;
  stroke-width: 3.4;
  filter: drop-shadow(0 0 5px rgba(59, 130, 246, 0.85));
}
.swd-lead.is-dim { opacity: 0.12; }

.cbd-card.is-path .cbd-card-rect {
  stroke-width: 3.2;
  filter: drop-shadow(0 0 10px var(--kind, var(--swd-accent)));
}
.cbd-card.is-dim { opacity: 0.5; }

.cbd-port.is-path rect {
  stroke: #f59e0b;
  stroke-width: 3;
}
.cbd-port.is-dim { opacity: 0.35; }

/* ── Vista de armarios (rack frontal) ─────────────────────────────────── */
.cbd-rack-frame {
  fill: color-mix(in srgb, var(--bg-card) 93%, var(--swd-accent) 7%);
  stroke: var(--slate-300, #cbd5e1);
  stroke-width: 2;
}
.cbd-rack-title {
  font-size: 12px;
  font-weight: 700;
  fill: var(--text-primary);
  letter-spacing: 0.02em;
}
.cbd-rack-slot {
  stroke: var(--border);
  stroke-width: 1;
  stroke-dasharray: 2 3;
  opacity: 0.55;
}
.cbd-rack-u {
  font-size: 7px;
  fill: var(--text-muted);
}
.cbd-rack-unit-rect {
  fill: var(--bg-surface);
  stroke: var(--kind, #94a3b8);
  stroke-width: 1.4;
}
.cbd-rack-unit-bar { fill: var(--kind, #94a3b8); }
.cbd-rack-unit-name {
  font-size: 9px;
  font-weight: 700;
  fill: var(--text-primary);
}
.cbd-rack-unit.is-path .cbd-rack-unit-rect {
  stroke-width: 2.6;
  filter: drop-shadow(0 0 8px var(--kind, var(--swd-accent)));
}
.cbd-rack-unit.is-dim { opacity: 0.5; }

.cbd-rack-note {
  font-size: 0.7rem;
  color: var(--text-muted);
  margin-left: 8px;
}
.cbd-port.is-rack .swd-port-num {
  font-size: 5.5px;
  font-weight: 700;
}
.cbd-port.is-rack.is-busy .swd-port-num { fill: #fff; }

/* Estado vacío del lienzo con acciones */
.swd-canvas-empty-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 0.85rem;
}

/* ── Cadena del puerto ────────────────────────────────────────────────────── */
.cbd-chain {
  border-top: 1px solid var(--border);
  padding: 0.6rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 210px;
  overflow: auto;
}
.cbd-chain-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}
.cbd-chain-node {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 5px 7px;
  border-radius: 6px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  font-size: 0.76rem;
}
.cbd-chain-node span { color: var(--text-muted); font-size: 0.7rem; }
.cbd-chain-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.74rem;
  color: var(--text-secondary);
  padding: 2px 4px;
}
.cbd-chain-row.is-backbone { font-weight: 600; color: #7c3aed; }
.cbd-chain-row.is-wall_run { color: #16a34a; }
.cbd-chain-row.is-outlet_through { font-style: italic; color: var(--text-muted); }
.cbd-chain-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Modal de cables de un puerto ─────────────────────────────────────────── */
.cbd-modal-wide { width: min(560px, 94vw); }
.cbd-edge-row {
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}
.cbd-edge-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 9px;
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border);
}
.cbd-edge-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 10px;
  background: rgba(59, 130, 246, 0.15);
  color: #1d4ed8;
}
.cbd-edge-tag.is-backbone { background: rgba(139, 92, 246, 0.16); color: #6d28d9; }
.cbd-edge-tag.is-wall_run { background: rgba(34, 197, 94, 0.16); color: #15803d; }
.cbd-edge-head .swd-link.is-danger { color: #dc2626; margin-left: auto; }
.cbd-edge-body {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  align-items: baseline;
  padding: 7px 10px;
  font-size: 0.79rem;
}
.cbd-edge-body em {
  font-style: normal;
  color: var(--text-muted);
  font-size: 0.72rem;
}

.cbd-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.9rem;
}
.cbd-field input {
  padding: 0.45rem;
  border-radius: 6px;
  border: 1px solid var(--slate-300, #cbd5e1);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.84rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/CablingDesigner.css"],"names":[],"mappings":"AAAA;;;;;iFAKiF;;AAEjF;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,oBAAoB,EAAE;AACnF,oBAAoB,oBAAoB,EAAE;;AAE1C,mEAAmE;AACnE,wCAAwC,aAAa,EAAE;;AAEvD,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA,+EAA+E;AAC/E,kBAAkB,aAAa,EAAE,sBAAsB,EAAE;AACzD,oCAAoC,eAAe,EAAE;AACrD;gFACgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,6BAA6B,6BAA6B,EAAE;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA,oDAAoD,0BAA0B,EAAE;AAChF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA,qDAAqD,UAAU,EAAE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA,sCAAsC,0BAA0B,EAAE,0BAA0B,EAAE;AAC9F,0BAA0B,YAAY,EAAE,eAAe,EAAE;AACzD,uBAAuB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC9G;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE,yBAAyB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,sBAAsB,6BAA6B,EAAE,0BAA0B,EAAE;AACjF,mBAAmB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAExE,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,+DAA+D;AACjE;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,WAAW,kBAAkB,EAAE;;AAE/B,qEAAqE;AACrE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qEAAqE;EACrE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kEAAkE;EAClE,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF,mBAAmB,kBAAkB,EAAE;AACvC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,gEAAgE;AAClE;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA,sBAAsB,6BAA6B,EAAE;AACrD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gFAAgF;AAChF;EACE,2DAA2D;EAC3D,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,gFAAgF;AAChF;yDACyD;AACzD,YAAY,YAAY,EAAE;AAC1B;EACE,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,qDAAqD;AACvD;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,oDAAoD;AACtD;AACA;EACE,qBAAqB;AACvB;AACA,4DAA4D;AAC5D;EACE,kFAAkF;EAClF,YAAY;AACd;AACA,gBAAgB,oCAAoC,EAAE;AACtD,iBAAiB,YAAY,EAAE;AAC/B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,sCAAsC,eAAe,EAAE;;AAEvD,gFAAgF;AAChF,YAAY,eAAe,EAAE;AAC7B;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;AACA,yBAAyB,qBAAqB,EAAE;AAChD,+BAA+B,aAAa,EAAE;AAC9C,yBAAyB,qBAAqB,EAAE;AAChD;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA,2BAA2B,aAAa,EAAE;AAC1C,wBAAwB,aAAa,EAAE;AACvC,0BAA0B,eAAe,EAAE,iBAAiB,EAAE;AAC9D;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;iCACiC,UAAU,EAAE;;AAE7C;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,mBAAmB,2BAA2B,EAAE;AAChD,mBAAmB,2BAA2B,EAAE;AAChD,uBAAuB,+BAA+B,EAAE;AACxD,kBAAkB,mBAAmB,EAAE;;AAEvC,gFAAgF;AAChF,2BAA2B,qBAAqB,EAAE;AAClD;EACE,uDAAuD;AACzD;AACA,uCAAuC,YAAY,EAAE;;AAErD;6EAC6E;AAC7E;EACE,oDAAoD;EACpD,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,KAAK,sBAAsB,EAAE;AAC/B;AACA;EACE,mCAAmC,eAAe,EAAE;AACtD;AACA,sDAAsD,eAAe,EAAE;AACvE,+CAA+C,eAAe,EAAE;AAChE,+CAA+C,eAAe,EAAE,UAAU,EAAE;AAC5E,kCAAkC,aAAa,EAAE;;AAEjD;mEACmE;AACnE;EACE,UAAU;EACV,iBAAiB;EACjB,qDAAqD;AACvD;AACA,mBAAmB,aAAa,EAAE;;AAElC;EACE,iBAAiB;EACjB,4DAA4D;AAC9D;AACA,mBAAmB,YAAY,EAAE;;AAEjC;EACE,eAAe;EACf,eAAe;AACjB;AACA,mBAAmB,aAAa,EAAE;;AAElC,4EAA4E;AAC5E;EACE,kEAAkE;EAClE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA,qBAAqB,0BAA0B,EAAE;AACjD;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,2DAA2D;AAC7D;AACA,wBAAwB,YAAY,EAAE;;AAEtC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA,0CAA0C,UAAU,EAAE;;AAEtD,yCAAyC;AACzC;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,mCAAmC;EACnC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;AACpB;AACA,uBAAuB,wBAAwB,EAAE,iBAAiB,EAAE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,6BAA6B,gBAAgB,EAAE,cAAc,EAAE;AAC/D,6BAA6B,cAAc,EAAE;AAC7C,mCAAmC,kBAAkB,EAAE,wBAAwB,EAAE;AACjF;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gFAAgF;AAChF,kBAAkB,uBAAuB,EAAE;AAC3C;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA,4BAA4B,oCAAoC,EAAE,cAAc,EAAE;AAClF,4BAA4B,mCAAmC,EAAE,cAAc,EAAE;AACjF,qCAAqC,cAAc,EAAE,iBAAiB,EAAE;AACxE;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────────\r\n   CablingDesigner — lienzo de extremos cableables\r\n   Reutiliza las clases `swd-*` del diseñador de switches (toolbar, lateral,\r\n   modal, zoom). Aquí solo va lo propio: filtros, cajas de armario, tarjetas\r\n   compactas, puertos y la ficha de cadena.\r\n   ──────────────────────────────────────────────────────────────────────────── */\r\n\r\n.cbd-page {\r\n  --cbd-wall: #22c55e;\r\n  --cbd-backbone: #8b5cf6;\r\n  --cbd-free: #86efac;\r\n  --cbd-busy: #3b82f6;\r\n  --cbd-external: #f59e0b;\r\n}\r\n\r\n/* Iconografía @heroicons/react/24/outline, mismo tamaño en toda la barra. */\r\n.cbd-ico {\r\n  width: 15px;\r\n  height: 15px;\r\n  flex: 0 0 auto;\r\n  stroke-width: 1.7;\r\n}\r\n.cbd-ico.is-kind { width: 13px; height: 13px; opacity: 0.75; vertical-align: -2px; }\r\n.swd-btn .cbd-ico { pointer-events: none; }\r\n\r\n/* Panel izquierdo plegado: el lienzo se queda con todo el ancho. */\r\n.swd-body.is-side-collapsed .swd-side { display: none; }\r\n\r\n/* Ojo y nombre con iconos (antes eran emojis). */\r\n.cbd-page .swd-eye {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--text-secondary);\r\n}\r\n.cbd-page .swd-side-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  min-width: 0;\r\n}\r\n\r\n/* ── Lista de nodos agrupada por tipo ────────────────────────────────────── */\r\n.cbd-side-group { display: flex; flex-direction: column; }\r\n.cbd-side-group + .cbd-side-group { margin-top: 2px; }\r\n/* La cabecera es un contenedor: dentro va el botón que pliega y las acciones\r\n   de ocultar/mostrar todo el grupo (un botón no puede llevar botones dentro). */\r\n.cbd-side-group-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  width: 100%;\r\n  padding: 0;\r\n  border-radius: 6px;\r\n  color: var(--text-secondary);\r\n}\r\n.cbd-side-group-head:hover { background: var(--bg-toolbar); }\r\n.cbd-side-group-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 5px 4px 5px 6px;\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  color: inherit;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  text-transform: uppercase;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n.cbd-side-group-head:hover .cbd-side-group-toggle { color: var(--text-primary); }\r\n.cbd-side-group-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 1px;\r\n  padding-right: 3px;\r\n  opacity: 0.55;\r\n  transition: opacity 0.12s;\r\n}\r\n.cbd-side-group-head:hover .cbd-side-group-actions { opacity: 1; }\r\n.cbd-group-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  padding: 0;\r\n  border: 0;\r\n  border-radius: 5px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n.cbd-group-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }\r\n.cbd-group-btn:disabled { opacity: 0.3; cursor: default; }\r\n.cbd-side-group-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.cbd-side-group-head em {\r\n  font-style: normal;\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  padding: 0 5px;\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* Acciones de la cabecera de la lista: ocultar todo / mostrar todo. */\r\n.cbd-side-head-actions { display: inline-flex; align-items: center; gap: 8px; }\r\n.cbd-head-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 1px 4px;\r\n  border: 0;\r\n  border-radius: 5px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n.cbd-head-btn:hover { background: var(--bg-toolbar); color: var(--text-primary); }\r\n.cbd-chain-title { display: inline-flex; align-items: center; gap: 6px; }\r\n\r\n/* ── Filtros por tipo ─────────────────────────────────────────────────────── */\r\n.cbd-filters {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 0.35rem 1rem;\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n}\r\n.cbd-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 3px 9px;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-card);\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  opacity: 0.55;\r\n  transition: opacity 0.12s, border-color 0.12s, background 0.12s;\r\n}\r\n.cbd-chip em {\r\n  font-style: normal;\r\n  font-size: 0.66rem;\r\n  background: var(--bg-toolbar);\r\n  border-radius: 8px;\r\n  padding: 0 5px;\r\n}\r\n.cbd-chip.is-on {\r\n  opacity: 1;\r\n  border-color: var(--chip);\r\n  color: var(--text-primary);\r\n  background: color-mix(in srgb, var(--chip) 12%, var(--bg-card));\r\n}\r\n.cbd-check {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-left: auto;\r\n  font-size: 0.73rem;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.cbd-select {\r\n  padding: 5px 9px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  font-size: 0.79rem;\r\n}\r\n.cbd-new { padding-right: 6px; }\r\n\r\n/* Modo: solo los nodos con cable a otro extremo dentro del filtro. */\r\n.cbd-only-connected {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.cbd-only-connected.is-on {\r\n  background: color-mix(in srgb, var(--swd-accent) 16%, var(--bg-card));\r\n  border-color: var(--swd-accent);\r\n  color: var(--text-primary);\r\n}\r\n.cbd-only-connected em {\r\n  font-style: normal;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: color-mix(in srgb, var(--swd-accent) 18%, transparent);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ── Selector de armarios ─────────────────────────────────────────────────── */\r\n.cbd-rack-picker { position: relative; }\r\n.cbd-rack-pop {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  left: 0;\r\n  z-index: 40;\r\n  width: 320px;\r\n  max-height: 380px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-surface);\r\n  box-shadow: var(--shadow-lg, 0 12px 30px rgba(15, 23, 42, 0.25));\r\n}\r\n.cbd-rack-pop input {\r\n  padding: 6px 8px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n}\r\n.cbd-rack-list {\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  max-height: 280px;\r\n}\r\n.cbd-rack-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  font-size: 0.78rem;\r\n  cursor: pointer;\r\n}\r\n.cbd-rack-row:hover { background: var(--bg-toolbar); }\r\n.cbd-rack-row em {\r\n  margin-left: auto;\r\n  font-style: normal;\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n}\r\n.cbd-rack-empty {\r\n  padding: 10px;\r\n  text-align: center;\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Cajas de armario / sede ──────────────────────────────────────────────── */\r\n.cbd-group rect {\r\n  fill: color-mix(in srgb, var(--swd-accent) 4%, transparent);\r\n  stroke: var(--border);\r\n  stroke-width: 1.4;\r\n  stroke-dasharray: 6 5;\r\n  cursor: grab;\r\n}\r\n.cbd-group:hover rect {\r\n  stroke: var(--swd-accent);\r\n  fill: color-mix(in srgb, var(--swd-accent) 7%, transparent);\r\n}\r\n.cbd-group-title {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  fill: var(--text-secondary);\r\n  letter-spacing: 0.02em;\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Tarjetas ─────────────────────────────────────────────────────────────── */\r\n/* Mismo lenguaje que el Diseñador de switches: cuerpo blanco con sombra,\r\n   borde suave y columna de información a la izquierda. */\r\n.cbd-card { cursor: grab; }\r\n.cbd-card-rect {\r\n  fill: var(--bg-surface);\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-width: 1.4;\r\n  filter: drop-shadow(0 2px 5px rgba(15, 23, 42, 0.14));\r\n}\r\n.cbd-card:hover .cbd-card-rect {\r\n  stroke: var(--kind, var(--swd-accent));\r\n  stroke-width: 2;\r\n  filter: drop-shadow(0 3px 9px rgba(15, 23, 42, 0.2));\r\n}\r\n.cbd-card.is-design .cbd-card-rect {\r\n  stroke-dasharray: 5 4;\r\n}\r\n/* Columna de información: tinte suave del color del tipo. */\r\n.cbd-card-info {\r\n  fill: color-mix(in srgb, var(--bg-toolbar, #eef2f7) 86%, var(--kind, #64748b) 14%);\r\n  cursor: grab;\r\n}\r\n.cbd-card-bar { fill: var(--kind, var(--swd-accent)); }\r\n.cbd-card-text { cursor: grab; }\r\n.cbd-card-name {\r\n  font-size: 11.5px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n}\r\n.cbd-card.is-compact .cbd-card-name { font-size: 11px; }\r\n\r\n/* ── Puertos ──────────────────────────────────────────────────────────────── */\r\n.cbd-port { cursor: pointer; }\r\n.cbd-port rect {\r\n  stroke: #0f172a22;\r\n  stroke-width: 1;\r\n  transition: fill 0.1s;\r\n}\r\n.cbd-port.is-free rect { fill: var(--cbd-free); }\r\n.cbd-port.is-free:hover rect { fill: #4ade80; }\r\n.cbd-port.is-busy rect { fill: var(--cbd-busy); }\r\n.cbd-port.is-external rect {\r\n  fill: var(--cbd-external);\r\n  stroke-dasharray: 2 1.5;\r\n}\r\n.cbd-port.is-legacy rect { fill: #fcd34d; }\r\n.cbd-port.is-off rect { fill: #cbd5e1; }\r\n.cbd-port.is-hover rect { stroke: #0f172a; stroke-width: 1.6; }\r\n.cbd-port.is-selected rect {\r\n  fill: #f59e0b;\r\n  stroke: #78350f;\r\n  stroke-width: 2;\r\n}\r\n.cbd-port.is-busy .swd-port-num,\r\n.cbd-port.is-off .swd-port-num { fill: #fff; }\r\n\r\n.cbd-dot {\r\n  display: inline-block;\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 50%;\r\n}\r\n.cbd-dot.is-free { background: var(--cbd-free); }\r\n.cbd-dot.is-busy { background: var(--cbd-busy); }\r\n.cbd-dot.is-external { background: var(--cbd-external); }\r\n.cbd-dot.is-off { background: #cbd5e1; }\r\n\r\n/* ── Cables ───────────────────────────────────────────────────────────────── */\r\n.cbd-edge .swd-edge-line { stroke-linecap: round; }\r\n.cbd-edge.is-backbone .swd-edge-line {\r\n  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.45));\r\n}\r\n.cbd-edge.is-wall_run .swd-edge-line { opacity: 0.9; }\r\n\r\n/* Camino completo del puerto (debajo del ratón o seleccionado): encendido y\r\n   con corriente recorriéndolo, para que se vea de un vistazo por dónde va. */\r\n.cbd-edge.is-path .swd-edge-line {\r\n  filter: drop-shadow(0 0 7px rgba(59, 130, 246, 0.9));\r\n  stroke-dasharray: 7 5;\r\n  animation: cbd-flow 0.6s linear infinite;\r\n}\r\n@keyframes cbd-flow {\r\n  to { stroke-dashoffset: -12; }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .cbd-edge.is-path .swd-edge-line { animation: none; }\r\n}\r\n.cbd-edge.is-path.is-port_connection .swd-edge-line { stroke-width: 5; }\r\n.cbd-edge.is-path.is-backbone .swd-edge-line { stroke-width: 9; }\r\n.cbd-edge.is-path.is-wall_run .swd-edge-line { stroke-width: 4; opacity: 1; }\r\n.cbd-edge.is-dim .swd-edge-line { opacity: 0.14; }\r\n\r\n/* El trocito de dentro de la tarjeta (del conector al borde) también se\r\n   enciende: si no, el camino parecía cortado justo en el puerto. */\r\n.swd-lead.is-path {\r\n  opacity: 1;\r\n  stroke-width: 3.4;\r\n  filter: drop-shadow(0 0 5px rgba(59, 130, 246, 0.85));\r\n}\r\n.swd-lead.is-dim { opacity: 0.12; }\r\n\r\n.cbd-card.is-path .cbd-card-rect {\r\n  stroke-width: 3.2;\r\n  filter: drop-shadow(0 0 10px var(--kind, var(--swd-accent)));\r\n}\r\n.cbd-card.is-dim { opacity: 0.5; }\r\n\r\n.cbd-port.is-path rect {\r\n  stroke: #f59e0b;\r\n  stroke-width: 3;\r\n}\r\n.cbd-port.is-dim { opacity: 0.35; }\r\n\r\n/* ── Vista de armarios (rack frontal) ─────────────────────────────────── */\r\n.cbd-rack-frame {\r\n  fill: color-mix(in srgb, var(--bg-card) 93%, var(--swd-accent) 7%);\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-width: 2;\r\n}\r\n.cbd-rack-title {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n  letter-spacing: 0.02em;\r\n}\r\n.cbd-rack-slot {\r\n  stroke: var(--border);\r\n  stroke-width: 1;\r\n  stroke-dasharray: 2 3;\r\n  opacity: 0.55;\r\n}\r\n.cbd-rack-u {\r\n  font-size: 7px;\r\n  fill: var(--text-muted);\r\n}\r\n.cbd-rack-unit-rect {\r\n  fill: var(--bg-surface);\r\n  stroke: var(--kind, #94a3b8);\r\n  stroke-width: 1.4;\r\n}\r\n.cbd-rack-unit-bar { fill: var(--kind, #94a3b8); }\r\n.cbd-rack-unit-name {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n}\r\n.cbd-rack-unit.is-path .cbd-rack-unit-rect {\r\n  stroke-width: 2.6;\r\n  filter: drop-shadow(0 0 8px var(--kind, var(--swd-accent)));\r\n}\r\n.cbd-rack-unit.is-dim { opacity: 0.5; }\r\n\r\n.cbd-rack-note {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n  margin-left: 8px;\r\n}\r\n.cbd-port.is-rack .swd-port-num {\r\n  font-size: 5.5px;\r\n  font-weight: 700;\r\n}\r\n.cbd-port.is-rack.is-busy .swd-port-num { fill: #fff; }\r\n\r\n/* Estado vacío del lienzo con acciones */\r\n.swd-canvas-empty-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  margin-top: 0.85rem;\r\n}\r\n\r\n/* ── Cadena del puerto ────────────────────────────────────────────────────── */\r\n.cbd-chain {\r\n  border-top: 1px solid var(--border);\r\n  padding: 0.6rem 0.75rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-height: 210px;\r\n  overflow: auto;\r\n}\r\n.cbd-chain-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-muted);\r\n}\r\n.cbd-chain-node {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  padding: 5px 7px;\r\n  border-radius: 6px;\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border: 1px solid rgba(59, 130, 246, 0.3);\r\n  font-size: 0.76rem;\r\n}\r\n.cbd-chain-node span { color: var(--text-muted); font-size: 0.7rem; }\r\n.cbd-chain-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.74rem;\r\n  color: var(--text-secondary);\r\n  padding: 2px 4px;\r\n}\r\n.cbd-chain-row.is-backbone { font-weight: 600; color: #7c3aed; }\r\n.cbd-chain-row.is-wall_run { color: #16a34a; }\r\n.cbd-chain-row.is-outlet_through { font-style: italic; color: var(--text-muted); }\r\n.cbd-chain-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Modal de cables de un puerto ─────────────────────────────────────────── */\r\n.cbd-modal-wide { width: min(560px, 94vw); }\r\n.cbd-edge-row {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  margin-bottom: 8px;\r\n  overflow: hidden;\r\n}\r\n.cbd-edge-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 5px 9px;\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.cbd-edge-tag {\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  padding: 2px 7px;\r\n  border-radius: 10px;\r\n  background: rgba(59, 130, 246, 0.15);\r\n  color: #1d4ed8;\r\n}\r\n.cbd-edge-tag.is-backbone { background: rgba(139, 92, 246, 0.16); color: #6d28d9; }\r\n.cbd-edge-tag.is-wall_run { background: rgba(34, 197, 94, 0.16); color: #15803d; }\r\n.cbd-edge-head .swd-link.is-danger { color: #dc2626; margin-left: auto; }\r\n.cbd-edge-body {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px 12px;\r\n  align-items: baseline;\r\n  padding: 7px 10px;\r\n  font-size: 0.79rem;\r\n}\r\n.cbd-edge-body em {\r\n  font-style: normal;\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.cbd-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.9rem;\r\n}\r\n.cbd-field input {\r\n  padding: 0.45rem;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--slate-300, #cbd5e1);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  font-size: 0.84rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
